import Cookies from 'js-cookie'

// Token的Cookie键名（与后端约定）
export const TOKEN_KEY = 'Admin-Token'

/**
 * 设置Token到Cookie
 * @param {string} token Token值
 * @param {object} options 配置（过期时间、路径、Secure等）
 */
export const setTokenCookie = (token, options = {}) => {
    if (token) {
        //兜底兼容，登录成功后把token放入本地缓存中一份
        localStorage.setItem(TOKEN_KEY, token)
    }
    // 默认配置：30天过期、根路径、生产环境开启Secure（HTTPS）
    const defaultOptions = {
        expires: 30, //  关键修改：从7天改为30天过期
        path: '/',
        // 生产环境强制Secure（仅HTTPS传输）
        secure: process.env.NODE_ENV === 'production',
        // 防止CSRF：SameSite=Strict/Lax（根据业务选，Lax兼容更好）
        sameSite: 'Lax'
    }
    // 合并配置（优先级：传入配置 > 默认配置）
    Cookies.set(TOKEN_KEY, token, { ...defaultOptions, ...options })
}

/**
 * 快捷配置：按分钟设置过期时间
 * @param {string} token Token值
 * @param {number} minutes 过期分钟数
 */
export const setTokenCookieByMinutes = (token, minutes = 2) => {
    const expires = new Date()
    expires.setTime(expires.getTime() + minutes * 60 * 1000) // 分钟转毫秒
    setTokenCookie(token, { expires })
}

/**
 * 设置会话级Cookie（关闭浏览器即失效，无过期时间）
 * @param {string} token Token值
 */
export const setSessionTokenCookie = (token) => {
    // 不设expires/maxAge，默认会话级
    setTokenCookie(token, { expires: undefined })
}

/**
 * 从Cookie获取Token
 * @returns {string|null} Token值（无则返回null）
 */
export const getTokenCookie = () => {
    // 优先读Cookie
    const cookieToken = Cookies.get(TOKEN_KEY)
    if (cookieToken) return cookieToken
    // 关键：Cookie偶发读取失败时，读localStorage兜底
    const storageToken = localStorage.getItem(TOKEN_KEY) || null
    return storageToken
}

/**
 * 清除Cookie中的Token
 */
export const removeTokenCookie = () => {
    localStorage.clear()
    Cookies.remove(TOKEN_KEY, { path: '/' }) // 路径需与设置时一致
}